<app-nav></app-nav>
<section class="email-section">
  <div class="container">
      <span id="snackbar"></span>
    <div class="col">
      <form name="emailForm" (ngSubmit)="formEmail.emailForm.valid" #formEmail="ngForm">
        <div id="chatBoxWindow" class="chat-box">
          <!-- Top Header -->
          <div class="chat-box-head">
            <div class="d-flex">
              <div class="p-2 mr-auto "><span id="queryBoxheader">Compose</span></div>
              <div class="p-2 ">
                  <input id="addAttachment" style="display: none" type="file" (change)="onFileChanged($event)" #fileInput
                  ng2FileSelect accept="image/x-png,image/jpeg,.png,image/jpg,.zip,.pdf,.doc,.dox,.xls,.xlsx" [uploader]="uploader" multiple>
                <img class="attachment-icon" (click)="fileInput.click()">
              </div>
              <div class="send-button" >
                <button class="send-icon" (click)="sentEmail()"></button>
              </div>
            </div>
          </div>
          <div class="chat-box-body">
            <div class="col">
              <div class="from-address">
                <div class="col">From</div>
                <div>{{FromId}}</div>
              </div>
              <div class="to-address">
                <div class="col">To</div>
                <div>help@securenow.in</div>
              </div>
              <div class="subject">
                <div class="col">Subject: </div>
                <div>Mail from Securenow - {{subName}}, {{subMobile}}</div>
              </div>
              <div class="col msg-body mt-4">
                <textarea placeholder="Type your message here" name="message" [(ngModel)]="message" rows="5" required></textarea>
                <div class="mt-2 mb-3 attachment-box">
                  <div class="" *ngIf="uploading">
                    <span class="spinner-border spinner-border-sm text-info"></span>
                    Uploading..
                  </div>
                  <span *ngIf="selectedFileName"><b>Attachment: </b></span><br>
                  <li *ngFor='let name of fileNameArray'>{{name}} <button class="btnDeleteFile" (click)="removeSelectedFile(index)"></button></li>
                </div>
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="fixed-footer">
      <div class="row footer-body">
        <div class="col text-center p-0" routerLink="/home"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Home-bordered.svg"
            class="img img-fluid" alt=""></div>
        <div class="col text-center p-0"><a href="tel:+919696683999"><img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/phone-bordered.svg"
              class="img img-fluid" alt=""></a></div>
        <div class="col text-center p-0"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/email-filled.svg"
            class="img img-fluid" alt=""></div>
        <div class="col text-center p-0" routerLink="/profile"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Profile-bordered.svg"
            class="img img-fluid" alt=""></div>
        <!--<div class="col text-center p-0" routerLink="/notifications-new"><img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/alarm-bordered.svg"
            class="img img-fluid" alt=""></div>-->
      </div>
    </div>
  </div>
  <div class="modal fade" id="emailSentModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
            <span [innerHtml]="successfullySentMessage" class=""></span>
          </div>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer text-center">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" routerLink="/home">Ok</button>
        </div>

      </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>